import React from 'react'
import RowButton from 'components/atoms/row-button'
import MultiselectColumnFilter from 'components/atoms/multiselect-column-filter'
import TimeUtil from 'utils/time-util'
import StringUtil from 'utils/string-util'
import PropTypes from 'prop-types'
import InternalRequestStatusBadge from 'domains/internal-request/atoms/status-badge'
import InternalRequestPurposeBadge from 'domains/internal-request/atoms/purpose-badge'


const actionCellPropTypes = {
  cell: PropTypes.shape({
    row: PropTypes.shape({
      original: PropTypes.object
    })
  })
}

const filterPropTypes = {
  column: PropTypes.object
}

/**
 * Columns definition for Seller Product Table
 * @param {object} categoryStatus - category of Internal Request status (reqest, ongoing, archive)
 * @param {Function} isButtonDisabled - function that will check whether the button on particular row is disabled
 * @param {Function} onButtonClick - function that will run when the button is clicked
 */
const InternalRequestRequestorTableColumns = ({
  categoryStatus,
  isButtonDisabled,
  buttonText,
  buttonColour,
  onButtonClick
}) => {
  // Custom Filter
  // Used to modify the filter in specific columns
  const StatusFilter = ({ column }) => {
    const options = Object.keys(categoryStatus).map((key) => (
      {
        label : StringUtil.titleCase(categoryStatus[key]),
        value : categoryStatus[key]
      }
    ))
    return (
      <MultiselectColumnFilter reactTableColumn={ column } options={ options } />
    )
  }

  StatusFilter.propTypes = filterPropTypes

  const StatusCell = (row) => <InternalRequestStatusBadge status={ row.cell.value } />

  const PurposeCell = (row) => <InternalRequestPurposeBadge purpose={ row.cell.value } />

  const DateCell = (row) => TimeUtil.format(row.cell.value)

  const ActionCell = ({ cell: { row } }) => {

    const disabled = isButtonDisabled ? isButtonDisabled(row.original) : false

    return (
      <div className='text-center'>
        <RowButton
          data={ row.original }
          color={ buttonColour }
          onClick={ onButtonClick }
          disabled={ disabled }
          text={ buttonText }
        />
      </div>
    )
  }

  ActionCell.propTypes = actionCellPropTypes

  return (
    [
      {
        Header   : 'Code',
        accessor : 'code'
      },
      {
        Header   : 'Status',
        accessor : 'status',
        Filter   : StatusFilter,
        Cell     : StatusCell
      },
      {
        Header         : 'Purpose',
        accessor       : 'purpose',
        disableFilters : true,
        Cell           : PurposeCell
      },
      {
        Header         : 'Request Date',
        accessor       : 'requested_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : 'Return Date',
        accessor       : 'returned_date',
        Cell           : DateCell,
        disableFilters : true
      },
      {
        Header         : 'Preorder Date',
        accessor       : 'preorder_date',
        Cell           : DateCell,
        disableFilters : false
      },
      {
        Header         : 'Action',
        id             : 'action',
        Cell           : ActionCell,
        disableFilters : true
      }
    ]
  )

}

export default InternalRequestRequestorTableColumns
